import http from 'plugins/axios';

export default {
  getList(data) {
    return http.post({
      url: '/la/admin/tradeStatistical/search',
      data,
      dataType: 'form'
    });
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/pair/list'
    });
  }
};
